import { render, staticRenderFns } from "./UpgradeLicenseModal.vue?vue&type=template&id=5e3c7853"
import script from "./UpgradeLicenseModal.vue?vue&type=script&lang=js"
export * from "./UpgradeLicenseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports